module.exports = __webpack_public_path__ + "img/introduce_item_icon1.636049ba.png";